<template>
  <div class="crm-header">
    <!-- logo -->
    <div class="logo">
      <img src="@/images/home/logo.png" alt="" />
    </div>
    <!-- 用户信息及退出 -->
    <div class="user-info">
      <span class="user-portrait">
        <i class="el-icon-user-solid"></i>
      </span>
      <el-dropdown placement="bottom">
        <span class="dropdown-touch">
          <span class="user-name">{{ userInfo.userName }}</span>
          <img src="@/images/icon/caret-bottom.png" alt="" />
        </span>
        <!-- <span class="dropdown-touch">

        </span> -->
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>姓名: {{ userInfo.userName }}</el-dropdown-item>
          <el-dropdown-item>团队: {{ userInfo.teamName }}</el-dropdown-item>
          <el-dropdown-item divided>
            <span class="logout" @click="loginOut">
              <i class="el-icon-switch-button"></i>
              退出登录
            </span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import service from '~api/user';

export default {
  data() {
    return {
      // logoutURL: '',
    };
  },
  computed: {
    ...mapGetters({
      userInfo: 'authority/userInfo',
    }),
  },
  created() {
    // 2021年05月13日15:33:00 已废弃
    // this.logoutURL = `${location.protocol}//${location.hostname}:${location.port}/quit`;
  },
  methods: {
    loginOut() {
      service.apiLogout().then((res) => {
        this.$message({
          type: 'success',
          message: '退出成功',
        });
      });
    },
  },
};
</script>

<style lang="less">
@import '~@/styles/const.less';

.crm-header {
  display: flex;
  justify-content: space-between;
  height: 100%;
  padding-right: 20px;
  background-color: @bg--white;
  box-shadow: @box-shadow;
  .logo {
    display: inline-flex;
    align-items: center;
    width: 200px;
    height: 50px;
    margin-left: 30px;
  }
  .user-info {
    display: inline-flex;
    align-items: center;
    .user-portrait {
      width: 30px;
      height: 30px;
      line-height: 30px;
      border-radius: 50%;
      background: #e5e5e5;
      text-align: center;
    }
    .user-name {
      min-width: 56px;
      display: inline-block;
      margin-left: 15px;
      line-height: 50px;
      text-align: right;
    }
    .el-dropdown {
      height: 50px;
      display: inline-flex;
      align-items: center;
      .dropdown-touch {
        display: flex;
        align-items: center;
        cursor: pointer;
      }
    }
  }
}
.el-dropdown-menu {
  padding: 0 10px !important;
  .el-dropdown-menu__item {
    color: @color--info;
    cursor: pointer;
  }
  .el-dropdown-menu__item:focus,
  .el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: @bg--white;
    color: @color--info;
  }
  .el-dropdown-menu__item--divided {
    border-top: 1px solid @border--gray;
    .logout {
      color: @color--primary;
      display: block;
      text-align: center;
      min-width: 204px;
      .el-icon-switch-button:before {
        font-weight: bold;
      }
    }
  }
}
</style>
